import React from 'react';
import styled from 'styled-components';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { IMeasureFilterValue } from '../../../../../redux/slices/oldBuilder';
import { IMeasureFilterState } from './types';
import { measureFilterSchema } from './validation';
import prepareMeasureFilterSubmitData from './utils/prepareMeasureFilterSubmitData';
import useDefaultMeasureFilterValues from './utils/useDefaultMeasureFilterValues';
import MeasureFilterFormFilters from './MeasureFilterFormFilters';
import MeasureFilterFormSubmit from './MeasureFilterFormSubmit';
import { useAppSelector } from '../../../../../redux/hooks';

interface IProps {
  options: IMeasureFilterValue[];
  onSubmit: (values: IMeasureFilterValue[]) => void;
  defaultValues: IMeasureFilterValue[];
  defaultMeasureKey?: string;
}

const FormContainer = styled.form`
  min-width: 726px;
`;

const MeasureFilterForm = ({
  options,
  onSubmit,
  defaultValues,
  defaultMeasureKey,
}: IProps) => {
  const parsedDefaultValues = useDefaultMeasureFilterValues(
    defaultValues,
    defaultMeasureKey,
  );

  const defaultMeasureRelOps = useAppSelector(
    ({ builder }) => builder.defaultMeasureRelOps,
  );

  const formMethods = useForm<IMeasureFilterState>({
    resolver: zodResolver(measureFilterSchema),
    defaultValues: parsedDefaultValues,
  });

  const { handleSubmit } = formMethods;

  const onSubmitForm = handleSubmit((formData) => {
    onSubmit(
      prepareMeasureFilterSubmitData(formData, options, defaultMeasureRelOps),
    );
  });

  return (
    <FormProvider {...formMethods}>
      <FormContainer onSubmit={onSubmitForm}>
        <MeasureFilterFormFilters options={options} />
        <MeasureFilterFormSubmit />
      </FormContainer>
    </FormProvider>
  );
};

export default MeasureFilterForm;
